export const site = {
  shortName: "Coach Elete",
  fullName: "Elete Gbolonyo",
  honorific: "Coach",
  brandTagline: "Building People Through Basketball.",
  brandPromise:
    "I don't just coach basketball. I build people, leaders, and successful programs.",
  brandTriad: ["People", "Leaders", "Programs"],
  heroTagline: "Building athletes. Building leaders. Building programs.",
  titles: [
    "Head Basketball Coach",
    "Player Development Coach",
    "Basketball Educator",
  ],
  location: "Vancouver, British Columbia, Canada",
  contact: {
    email: "coache.lucius@gmail.com",
    linkedin: "https://www.linkedin.com/in/mawulete-gbolonyo-6292711b3/",
    instagram: "https://www.instagram.com/coachelete/",
    linkedinLabel: "Mawulete Gbolonyo",
    instagramLabel: "@coachelete",
  },
};

// PRIMARY PUBLIC NAVIGATION — six focused pages. Every page answers:
// "Why should someone trust Coach Elete?"
export const navPrimary = [
  { label: "Home", to: "/" },
  { label: "Philosophy", to: "/philosophy" },
  { label: "Experience", to: "/resume" },
  { label: "Alumni", to: "/legacy" },
  { label: "Contact", to: "/contact" },
];

// ARCHIVED — hidden from public navigation for now, but routes & code remain
// intact. Intended to return later as part of a content hub ("Coach's Corner" /
// "Film Room" / "Resources"). To re-enable, surface these in the Navbar/Footer.
export const navArchived = [
  { label: "Program Blueprint", to: "/blueprint" },
  { label: "Player Development", to: "/player-development" },
  { label: "Coaching Journal", to: "/journal" },
  { label: "Media", to: "/media" },
];

// Flat list (used by footer / sitemap-style listings).
export const navLinks = navPrimary;
